// extracted by mini-css-extract-plugin
export default {"title":"AddAnnouncement_title__uQZeT","inputform":"AddAnnouncement_inputform__+hHc5"};